module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.componentKey,
    staticClass: "pager",
    staticStyle: {
      "background": "#fcfcfc"
    }
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "0em",
      "text-align": "left"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {}, [_vm._l((_vm.checkout_orders), function(order_data, index) {
    return _c('div', {
      staticClass: "group-row gp-row00 container",
      staticStyle: {
        "margin": "1em 2em",
        "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
      }
    }, [_c('div', [_vm._m(0, true), _vm._v(" "), _c('div', [_c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(order_data.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(order_data.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
      style: ({
        color: order_data.order_status_color
      })
    }, [_vm._v(_vm._s(order_data.order_status))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(order_data.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(order_data.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(order_data.order_total))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(order_data.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(order_data.order_user_delivery_address))])])]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("jkj\r\n                        " + _vm._s(order_data.order_chart) + "\r\n                        "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.setOrderCustomMakePaymentUpdate(order_data)
        }
      }
    }, [_vm._v("pay")])]), _vm._v(" "), _c('label', [_vm._v("Order Payment Receipt")]), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": "prImagePreview"
      }
    }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('p', [(_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Uploading Receipt: " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomUploadReceipt(order_data)
        }
      }
    }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px",
        "background-color": "#f5f4e6",
        "color": "#000000"
      },
      on: {
        "click": function($event) {
          _vm.file_info = []
        }
      }
    }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomUpdates(order_data, 'received')
        }
      }
    }, [_vm._v("Mark as received")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomUpdates(order_data, 'closed')
        }
      }
    }, [_vm._v("Close Order")])])])
  }), _vm._v(" "), (_vm.checkout_orders.length != 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [(!_vm.checkout_processed) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin": "0 1em",
      "margin-top": "-1em"
    }
  }, [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Billing details")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "13px"
    }
  }, [_vm._v("Enter the details below to Checkout"), _c('br'), _vm._v(" "), (_vm.new_account) ? _c('span', [_vm._v("Do you have a "), _c('b', [_vm._v("Buypoint Account? ")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("You can use it to process your orders")])]) : _c('span', [_vm._v("Don't have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('new-account', '')
      }
    }
  }, [_vm._v("Click Here")])])])]), _vm._v(" "), _c('div', {}, [(_vm.new_account) ? _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "id": "Last-name-2"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "number",
      "placeholder": "Phone No"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.prep_process_checkout
    }
  }, [_vm._v("Process Checkout")])])])]) : _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-groupw"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loginAndProcess()
      }
    }
  }, [_vm._v("Process Checkout")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Items to Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "margin-top": "-1em"
    }
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "height": "auto"
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "1em"
      }
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding-top": "1em"
        }
      }, [_c('div', [_c('div', {
        staticStyle: {
          "width": "30%",
          "float": "left"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        staticStyle: {
          "height": "80px"
        },
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        staticStyle: {
          "height": "80px"
        },
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "60%",
          "float": "right"
        }
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('p', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v(" Qty: " + _vm._s(item.product_item_order_quantity))]), _c('br'), _vm._v(" "), _c('p', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("  ₦" + _vm._s(_vm.formatCurrency_2(item.product_item_price * item.product_item_order_quantity)))]), _c('br'), _vm._v(" "), (group.order_items.length > 1) ? _c('div', {
        staticClass: "col-xs-9 pull-right"
      }, [(item.calculated_product_delivery_fee > 0) ? _c('p', [_vm._v("This item's Shipping Fee: " + _vm._s(item.calculated_product_delivery_fee))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "clear": "both",
        "width": "100%",
        "border-top": "#f3f0f0 solid 1px",
        "padding-top": "1em",
        "padding-bottom": "1em"
      }
    }, [(group.total_order_coupons_amount != 0) ? _c('div', [_vm._m(2, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.total_order_coupons_amount).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(3, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.order_total_amount).toFixed(2)))])]), _vm._v(" "), (group.order_total_delivery_charge > 0) ? _c('div', [_vm._m(4, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s(group.order_total_delivery_charge))])]) : _vm._e()])], 2)])
  }))])]) : _c('div', {
    staticClass: "container"
  }, [(!_vm.flexi_pay) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "margin-top": "0.5em"
    }
  }, [(Object.keys(_vm.share_cart_details).length > 0) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "text-align": "center",
      "background": "#ff0066",
      "color": "#ffffff",
      "height": "auto",
      "padding": "2em",
      "border-radius": "5px"
    }
  }, [_c('h3', [_vm._v("Share Cart Order")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(5), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.app_url) + "sharecart/" + _vm._s(_vm.share_cart_details.order_share_cart_ref_link))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF-CODE: ")]), _vm._v(_vm._s(_vm.share_cart_details.order_share_cart_ref_code))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.copyLink(_vm.app_url + 'sharecart/' + _vm.share_cart_details.order_share_cart_ref_link, 'MAINSHCRCOPY')
      }
    }
  }, [_vm._v("Copy Link")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    },
    attrs: {
      "id": "MAINSHCRCOPY"
    }
  }, [_vm._v("Copied")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row cktop ck-card-row card",
    staticStyle: {
      "background": "#ffffff",
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "mobi-on"
  }, [_c('p', [_c('b', [_c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("\r\n                                            Total")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_orders_amount)))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1.5em 2.5em"
    }
  }, [_vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row gp-row00",
      staticStyle: {
        "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#000000",
        "color": "#ffffff",
        "margin": "-8px",
        "padding": "0 8px",
        "padding-top": "6px",
        "border-radius": "15px 15px 0px 0px"
      }
    }, [_c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(group.order_time_ago))]), _vm._v(" "), (group.order_is_business_agent && (group.order_is_business_agent == 1)) ? _c('p', {
      staticClass: "sp-app-default-color-off"
    }, [_c('b', [_vm._v(_vm._s(group.order_business_agent_name))])]) : _c('p', {
      staticClass: "sp-app-default-color-off"
    }, [_vm._v("Shop: "), _c('b', [_vm._v(_vm._s(group.order_business))])]), _vm._v(" "), ((group.order_business_agent_type && (group.order_business_agent_type == 19))) ? _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Selling for: ")]), _c('b', [_vm._v(_vm._s(group.order_business))])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (((Object.keys(_vm.share_cart_details).length == 0) && (Object.keys(group.order_share_cart_details).length > 0))) ? _c('div', [_c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#ff0066",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView(_vm.menu_tab_inner_view['SHCR' + index] ? ' ' : 'SHCR' + index)
        }
      }
    }, [_vm._v("Share "), _c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SHCR' + index]) ? _c('div', {
      staticClass: "card card-flat-pad",
      staticStyle: {
        "text-align": "center",
        "border": "3px solid #ff0066",
        "color": "inherit",
        "height": "auto",
        "padding": "2em",
        "border-radius": "5px"
      }
    }, [_c('h3', [_vm._v("Share Cart Order")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._m(6, true), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.app_url) + _vm._s(group.order_share_cart_details.order_share_cart_ref_link))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF-CODE: ")]), _vm._v(_vm._s(group.order_share_cart_details.order_share_cart_ref_code))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.copyLink(_vm.app_url + group.order_share_cart_details.order_share_cart_ref_link, 'SHCRCOPY')
        }
      }
    }, [_vm._v("Copy Link")]), _vm._v(" "), (_vm.copied) ? _c('span', {
      staticStyle: {
        "background": "rgb(240, 227, 157)"
      },
      attrs: {
        "id": "SHCRCOPY"
      }
    }, [_vm._v("Copied")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((group.order_items_groups), function(item_group, igdex) {
      return _c('div', {
        staticClass: "row ck-card-row",
        staticStyle: {
          "clear": "both"
        }
      }, [_vm._v(_vm._s(igdex) + "\r\n                                    "), _vm._l((item_group), function(item) {
        return _c('div', {}, [_c('div', {
          staticStyle: {
            "width": "30%",
            "float": "left"
          }
        }, [_c('a', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "href": item.product_url
          }
        }, [((item.product_item_group_image && (item.product_item_group_image != ''))) ? _c('img', {
          staticClass: "sp-prd-img",
          attrs: {
            "src": item.product_item_group_image
          }
        }) : _c('img', {
          staticClass: "sp-prd-img",
          attrs: {
            "src": "/static/assets/images/dummy-image.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "width": "60%",
            "float": "right"
          }
        }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _c('p', [_vm._v(_vm._s(item.order_item_is_an_addon_to) + "--" + _vm._s(item.order_item_addon))]), _vm._v(" "), _c('p', [_vm._v(" QTY: " + _vm._s(item.order_item_quantity))]), _vm._v(" "), _c('p', [(item.order_item_quantity > 1) ? _c('span', {
          staticClass: "price"
        }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_total_price.toFixed(2))), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(item.order_item_total) + "\r\n                                            ")])]), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
          staticStyle: {
            "clear": "both",
            "width": "100%",
            "border-top": "#f3f0f0 solid 1px",
            "padding-top": "1em"
          }
        }, [_vm._m(7, true), _vm._v(" "), ((group.order_items.length > 1)) ? _c('div', {
          staticStyle: {
            "clear": "both"
          }
        }, [(item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "#ff0000",
            "float": "left"
          }
        }, [_vm._v("Product Shipping Fee:")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("₦" + _vm._s(item.order_item_delivery_fee))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "#ff0000",
            "float": "left"
          }
        }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "left"
          }
        }, [_vm._v(" ₦" + _vm._s(item.order_item_total_delivery_fee))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
          staticStyle: {
            "float": "right",
            "margin-bottom": "5px",
            "display": "none"
          }
        }, [_c('span', [_c('a', {
          staticClass: "mobi-on",
          staticStyle: {
            "cursor": "pointer",
            "color": "#000000"
          },
          on: {
            "click": function($event) {
              _vm.removeFromCheckout(index, group, item)
            }
          }
        }, [_vm._v("Remove")]), _vm._v(" "), _c('a', {
          staticClass: "mobi-off",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              _vm.removeFromCheckout(index, group, item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-close"
        }), _vm._v("Remove")])])])]) : _vm._e()])
      })], 2)
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
      key: _vm.processed_single_order_count,
      staticClass: "c-cart-totals"
    }, [_c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "74%",
        "float": "left",
        "padding": "3px"
      }
    }, [(group.order_delivery_city) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: " + _vm._s(group.order_delivery_city))]) : _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: Not set yet")]), _vm._v(" "), (group.order_user_delivery_address) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(group.order_user_delivery_address))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [(group.order_delivery_city) ? _c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('cdl' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'cdl' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#ffffff dashed 1px",
        "margin": "2em 0 2em 0",
        "padding-bottom": "2em"
      }
    }, [_c('div', {
      staticClass: "pull-right",
      staticStyle: {
        "display": "none"
      }
    }, [(group.change_shipping) ? _c('a', {
      on: {
        "click": function($event) {
          group.change_shipping = false
        }
      }
    }, [_vm._v("CANCEL: Change Shipping")]) : _c('a', {
      on: {
        "click": function($event) {
          group.change_shipping = true
        }
      }
    }, [_vm._v("Change Shipping")])]), _vm._v(" "), (group.change_shipping) ? _c('div', [((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0))) ? _c('div', [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Shipping Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_custom), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('label', [_vm._v("OR Select State In Nigeria")]) : _c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getOrderLocations(index, group.order_delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('div', {
      staticClass: "loading-sm"
    })]) : _vm._e()]), _vm._v(" "), (group.sorted_order_business_delivery_options) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.sorted_order_business_delivery_options), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2)]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(group.order_delivery_selected_state.state_id)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.cities.length > 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.resetDeliveryLocation(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (group.order_delivery_city) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [(group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                                    " + _vm._s(address.address_address) + "\r\n                                                                ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Enter Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_user_delivery_address),
        expression: "group.order_user_delivery_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (group.order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_user_delivery_address = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('button', {
      staticClass: "pull-right btn btn-default sp-button-02 sp-button-md",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])]), _vm._v(" "), _c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%",
        "float": "left",
        "padding": "3px"
      }
    }, [_c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(Object.keys(group.order_items).length) + " Item(s)")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('orditms' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'orditms' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#f5f4e6 dashed 1px",
        "margin": "1em 0 2em 0",
        "padding": "1em"
      }
    }, [((group.order_items && (group.order_items.length != 0))) ? _c('div', [_c('p', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("Items Ordered")]), _vm._v(" "), _vm._l((group.order_items), function(item) {
      return _c('div', [_c('div', {
        staticStyle: {
          "width": "15%",
          "float": "left"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "80%",
          "float": "right",
          "padding": "3px"
        }
      }, [_c('p', [_vm._v("\r\n                                                                " + _vm._s(item.product_name)), _c('br'), _vm._v("\r\n                                                                Quantity:  " + _vm._s(item.order_item_quantity)), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(item.order_item_total)))])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])
    })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [(group.order_payment_enabled == 1) ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(10, true), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('paytl' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'paytl' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(group.data_processing_message))]), _vm._v(" "), ((group.order_delivery_city != undefined || group.order_delivery_city != '')) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [(((group.order_user_delivery_address == '' || (group.order_user_delivery_address == undefined)))) ? _c('div', [_c('label', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Enter Shipping Address For "), _c('b', [_vm._v(_vm._s(group.order_delivery_city))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_user_delivery_address),
        expression: "set_order_user_delivery_address"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (_vm.set_order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.set_order_user_delivery_address = $event.target.value
        }
      }
    }), _vm._v(" "), (group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                                        " + _vm._s(address.address_address) + "\r\n                                                                    ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('close-enter-delivery-address', index)
        }
      }
    }, [_vm._v("Done")])])]) : _vm._e(), _vm._v(" "), (group.order_user_delivery_address != '' && (group.order_user_delivery_address != undefined)) ? _c('div', [(group.order_user_delivery_address != '' && (group.order_user_delivery_address != undefined)) ? _c('button', {
      staticClass: "pull-right btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "color": "#ffffff",
        "background": "#fc4848"
      },
      attrs: {
        "id": 'PAYPOS' + index
      },
      on: {
        "click": function($event) {
          _vm.setProcessPaymentSingle(group, index, 'POS' + index);
          _vm.closeViews('PAYPOS' + index)
        }
      }
    }, [_vm._v("Make Payment")]) : _vm._e()]) : _vm._e()]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Please set your delivery place.")]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'POS' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "clear": "both",
        "margin": "0.1em"
      }
    }, [_c('h3', [_vm._v("Select a payment method\r\n                                                            "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.closeViews('POS' + index);
          _vm.toggleSingleComponent('PAYPOS' + index);
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('br'), _vm._v(" "), (group.order_cap_payment_banks) ? _c('div', [(((group.business_bank_details.length != 0) || (group.business_agent_bank_details.length != 0))) ? _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "color": "inherit"
      }
    }, [_c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.toggleViews('BBanks' + index)
        }
      }
    }, [_vm._m(12, true), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ibox",
      staticStyle: {
        "display": "none",
        "border": "1px solid #ccc",
        "padding": "1.05em"
      },
      attrs: {
        "id": 'BBanks' + index
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "1em !important"
      }
    }, [(group.order_can_part_payment && (group.order_part_payment_amount > 0)) ? _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(group.order_part_payment_amount)))]) : _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency_2(group.total_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Ref: ")]), _vm._v(_vm._s(group.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Pay to:")]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-xs sp-button-02 sp-button-sm",
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [(_vm.action_loading) ? _c('div', [_c('i', {
      staticClass: "fas fa-circle-notch fa-spin fa-2x"
    })]) : _c('span', [_vm._v("Confirm Transfer")])])]), _vm._v(" "), _vm._l((group.business_bank_details), function(bank) {
      return (group.order_receive_manual_payment_by == 1) ? _c('div', [_vm._v("\r\n                                                                            " + _vm._s(bank) + "\r\n                                                                        ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.business_agent_bank_details), function(bank) {
      return (group.order_receive_manual_payment_by == 2) ? _c('div', [_vm._v("\r\n                                                                            " + _vm._s(bank) + "\r\n                                                                        ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('div')]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01"
    }, [_c('div', {
      staticStyle: {
        "width": "95%",
        "float": "left"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('div', {
      staticStyle: {
        "clear": "both"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 2, 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections "), _c('br'), _vm._v("-"), _c('b', [_c('i', [_vm._v("You have ")]), _vm._v("NGN: " + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])]) : _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections:"), _c('br'), _vm._v(" "), _c('b', [_c('i', [_vm._v("- You have ")]), _vm._v("NGN:" + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "5%",
        "margin-top": "0.8em"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('span', [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "btn btn-default",
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [((Object.keys(_vm.order_gift_card).length > 0) && (_vm.order_gift_card.order_gift_card_data)) ? _c('div') : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessGiftCardPayment(group, index, 7, 0)
        }
      }
    }, [_vm._v("Pay with Gift Cards")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_gift_card.gift_card_ref),
        expression: "set_gift_card.gift_card_ref"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.set_gift_card.gift_card_ref)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.set_gift_card.gift_card_ref = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.setProcessGiftCardPayment(group, index, 0, 0, 0)
        }
      }
    }, [_vm._v("SENDs")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessGiftCardPayment(group, index, 7, 0)
        }
      }
    }, [_vm._v("Use Gift Card for Payment")])])]), _vm._v(" "), _c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 1, 0)
        }
      }
    }, [_vm._m(14, true), _vm._v(" "), _vm._m(15, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "0.8em"
      }
    }, [_c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Subtotal:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_items_total.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Shipping:")]), _vm._v(" "), (group.order_delivery_fee >= 0) ? _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_delivery_fee))]) : _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_delivery_fee.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), (group.order_processing_fee_client_pay) ? _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Processing Fee:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_processing_fee.toFixed(2)))])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.total_amount.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), ((group.order_can_part_payment && (group.order_can_part_payment == 1))) ? _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Part Payment Amount:"), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("(Total paid: "), _c('b', [_vm._v(_vm._s(_vm.formatCurrency(group.order_part_payment_total_amount_paid)))]), _vm._v(")")]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#0077ff",
        "font-size": "12px"
      }
    }, [_vm._v("(Total to pay: "), _c('b', [_vm._v(_vm._s(_vm.formatCurrency((group.total_amount - group.order_part_payment_total_amount_paid))))])])]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_part_payment_amount),
        expression: "group.order_part_payment_amount"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (group.order_part_payment_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_part_payment_amount = $event.target.value
        }
      }
    })])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p')]), _vm._v(" "), (group.order_payment_enabled == 0) ? _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#ffa800",
        "width": "92vw",
        "padding": "0.8em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#ffffff",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.updateOrders(group, index, 'requested')
        }
      }
    }, [(_vm.action_loading) ? _c('span', [_c('i', {
      staticClass: "fas fa-circle-notch fa-spin fa-2x"
    })]) : _c('span', [_vm._v("Place Order")])])])]) : _vm._e()]) : (group.order_part_payment_status == 200) ? _c('div', {
      staticClass: "c-cart-totals",
      staticStyle: {
        "border": "solid 1px#ffa800",
        "text-align": "center"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ffa800",
        "padding-top": "5px"
      }
    }, [_vm._v("Part Payment Order Placed")])]) : _c('div', {
      staticClass: "c-cart-totals",
      staticStyle: {
        "border": "none",
        "text-align": "left"
      }
    }, [_vm._m(16, true)])], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em"
    }
  }), _vm._v(" "), (_vm.processed_single_order_count > 0) ? _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "bottom": "4em"
    }
  }, [_vm._m(17)]) : _vm._e()], 2)]) : _c('div', [((Object.keys(_vm.checkout_orders).length == 0)) ? _c('div', {
    staticStyle: {
      "margin": "20vh 40vw"
    }
  }, [_vm._m(18)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.checkout_orders), function(group, index) {
    return (_vm.flexi_active_payment_status == 0) ? _c('div', {
      staticStyle: {
        "border": "none"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_vm._m(19, true), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(group.total_amount)))]), _vm._v(" "), _vm._m(20, true), _vm._v(" "), (group.business_bank_details && (Object.keys(group.business_bank_details).length > 0)) ? _c('div', [_c('div', [_c('p', [_vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_name)), _c('br'), _vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_account_name)), _c('br'), _vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_account_number)), _c('br')])])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(21, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('paytl' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "background": "none"
      },
      attrs: {
        "id": 'paytl' + index
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "0.1em 0.2em"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("After Transfer >>")]), _vm._v(" "), _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin-bottom": "0.3em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transfer_verification_mode),
        expression: "transfer_verification_mode"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(_vm.transfer_verification_mode, "1")
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('transfer_verification_mode_ref')
        },
        "__c": function($event) {
          _vm.transfer_verification_mode = "1"
        }
      }
    }), _vm._v(" Enter Reference No/Code\r\n                                                "), (group.order_payment_third_party_ref && (group.order_payment_third_party_ref != 1)) ? _c('span', [_vm._v(" - " + _vm._s(group.order_payment_third_party_ref))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transfer_verification_mode),
        expression: "transfer_verification_mode"
      }],
      attrs: {
        "type": "radio",
        "value": "2"
      },
      domProps: {
        "checked": _vm._q(_vm.transfer_verification_mode, "2")
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('transfer_verification_mode_receipt')
        },
        "__c": function($event) {
          _vm.transfer_verification_mode = "2"
        }
      }
    }), _vm._v(" Or Upload Transfer Receipt\r\n                                            ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), (_vm.menu_tab_inner_view.transfer_verification_mode_ref) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [_c('p', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Please enter Reference Code or Number found on your Bank (or Other) Transaction Message")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group wnf-fl-form-group col-xs-12"
    }, [_vm._v("--" + _vm._s(group.order_payment_third_party_ref) + "\r\n                                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_payment_third_party_ref),
        expression: "group.order_payment_third_party_ref"
      }],
      staticClass: "form-control input-bflat",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (group.order_payment_third_party_ref)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_payment_third_party_ref = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button btn-xs",
      staticStyle: {
        "width": "20vw",
        "margin-left": "60vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [_vm._v("Enter")])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.transfer_verification_mode_receipt) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [((Object.keys(_vm.file_info).length == 0)) ? _c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('p', [(_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Uploading Receipt: " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px",
        "background-color": "#f5f4e6",
        "color": "#000000"
      },
      on: {
        "click": function($event) {
          _vm.file_info = []
        }
      }
    }, [_vm._v("Cancel")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    })])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "2.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(22, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('payopt' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "background": "none"
      },
      attrs: {
        "id": 'payopt' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(group.data_processing_message))]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'POS' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "clear": "both",
        "margin": "0",
        "padding": "0.4em"
      }
    }, [_c('p', {
      staticStyle: {
        "display": "none"
      }
    }, [_vm._v("Select a payment method\r\n                                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "card  card-colord-pad-01"
    }, [_c('div', {
      staticStyle: {
        "width": "95%",
        "float": "left"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('div', {
      staticStyle: {
        "clear": "both"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 2, 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections "), _c('br'), _vm._v("-"), _c('b', [_c('i', [_vm._v("You have ")]), _vm._v("NGN: " + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])]) : _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections:"), _c('br'), _vm._v(" "), _c('b', [_c('i', [_vm._v("- You have ")]), _vm._v("NGN:" + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "5%",
        "margin-top": "0.8em"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('span', [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card  card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 1, 0)
        }
      }
    }, [_vm._m(23, true), _vm._v(" "), _vm._m(24, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.flexi_active_payment_status == 1) ? _c('div', [_c('div', {
    key: _vm.componentOrderSummaryKey,
    staticClass: "row",
    staticStyle: {
      "margin": "1.4em 0"
    }
  }, [_vm._m(25), _vm._v(" "), _vm._m(26)]), _vm._v(" "), _vm._m(27)]) : _vm._e()], 2)])]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(28)])], 2)]), _vm._v(" "), (!_vm.flexi_pay) ? _c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('component-footer')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "margin": "-8px",
      "padding": "0.51em",
      "padding-top": "6px",
      "border-radius": "5px 5px 0px 0px"
    }
  }, [_c('h3', [_vm._v("Order Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "margin": "-8px",
      "padding": "0.51em",
      "padding-top": "6px",
      "border-radius": "5px 5px 0px 0px"
    }
  }, [_c('h3', [_vm._v("Payment Details")]), _vm._v(" "), _c('p', [_vm._v("To make payment use the details below")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Coupon Discount Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Order Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Shipping Fee:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Share Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Share Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("Gift/Send this Product to a different location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "16%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Location:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Items:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Payment:    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "75%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "14px"
    }
  }, [_vm._v("No Payment Mode selected")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v("Direct Bank Transfer"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Pay directly to Business Bank Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Automatic Bank transfer and"), _c('br'), _vm._v(" Debit Card Payments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#ffa800",
      "font-weight": "bold"
    }
  }, [_vm._v(">>")]), _vm._v(" Order Placed\r\n                                        "), _c('span', [_c('a', {
    staticStyle: {
      "float": "right",
      "color": "#ffa800",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("View Orders")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("View Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sp-app-default-color"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('b', [_vm._v("Transfer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("To:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "16px",
      "color": "#ff0000"
    }
  }, [_vm._v("Complete Transfer Verification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("Pay with other options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Automatic Bank transfer and"), _c('br'), _vm._v(" Debit Card Payments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "24px"
    }
  }, [_c('b', [_vm._v("Transfer Payment registered successfully")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "3em 0"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "padding": "0.31em",
      "border-radius": "50%",
      "border": "#ff0000 solid",
      "font-size": "5em",
      "color": "#ff0000"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "bottom": "0em"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("Done, View Orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-top": "2em"
    }
  }, [_vm._v("No Orders for Checkout")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn default",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Shop Here")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50220e4c"}!./src/pages/Orderpoint/OrderRequest/template.html
// module id = 540
// module chunks = 0